import React, { useState } from "react";
import { collection, addDoc, doc, setDoc } from "firebase/firestore";
import { firestore } from "../firebase";

function Upload() {
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [addedPrices, setAddedPrices] = useState([]);
  const [imgUrls, setImgUrls] = useState([]);
  const [price, setPrice] = useState(0);
  const [tags, setTags] = useState([]);
  const [tally, setTally] = useState(0);
  const [time, setTime] = useState(0);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const docData = {
      name: name,
      category: category,
      description: description,
      details: {
        short: shortDescription,
        addedPrices: addedPrices,
      },
      imgUrl: imgUrls,
      price: price,
      tags: tags,
      tally: tally,
      time: time,
    };

    const slugId = name.toLowerCase().replace(/\s+/g, "-");

    try {
      const docRef = doc(collection(firestore, "services"), slugId); // Use slugId as document ID
      await setDoc(docRef, docData);

      alert("Document uploaded successfully!");
      setName("");
      setCategory("");
      setDescription("");
      setShortDescription("");
      setAddedPrices([]);
      setImgUrls([]);
      setPrice(0);
      setTags([]);
      setTally(0);
      setTime(0);

      console.log("Document written with ID: ", docRef.id);
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  return (
    <div>
      <h2>Upload New Service</h2>
      <form
        onSubmit={handleSubmit}
        className="upload flex column align-center justify-between"
      >
        <label>Name:</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <label>Category:</label>
        <input
          type="text"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
        <label>Description:</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        {/* ... Previous fields ... */}
        <label>Short Description:</label>
        <textarea
          value={shortDescription}
          onChange={(e) => setShortDescription(e.target.value)}
        />

        <label>Added Prices:</label>
        <input
          type="text"
          placeholder="Enter added prices (comma-separated)"
          value={addedPrices.join(",")}
          onChange={(e) => setAddedPrices(e.target.value.split(","))}
        />

        <label>Image URLs:</label>
        <input
          type="text"
          placeholder="Enter image URLs (comma-separated)"
          value={imgUrls.join(",")}
          onChange={(e) => setImgUrls(e.target.value.split(","))}
        />

        <label>Price:</label>
        <input
          type="number"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />

        <label>Tags:</label>
        <input
          type="text"
          placeholder="Enter tags (comma-separated)"
          value={tags.join(",")}
          onChange={(e) => setTags(e.target.value.split(","))}
        />

        <label>Tally:</label>
        <input
          type="number"
          value={tally}
          onChange={(e) => setTally(e.target.value)}
        />

        <label>Time:</label>
        <input
          type="number"
          value={time}
          onChange={(e) => setTime(e.target.value)}
        />
        {/* ... Submit button */}

        <button type="submit" className="button button-primary">
          Upload
        </button>
      </form>
    </div>
  );
}

export default Upload;
